import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-darkCharcoal text-xs text-center text-softWhite py-4 px-6 mt-auto">
      <p>&copy; {new Date().getFullYear()} AuctionApex. All rights reserved.</p>
    </footer>
  )
}

export default Footer
